export default {
  'clocks': [
    'clock0900_1230',
    'clock1330_1800'
  ],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage'
  ],
  'requiredFields': {
    'default': [
      'Company',
      'PostalCode',
    ],
    'consulting': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'offersGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'offersInvestment': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'other': [
      'PostalCode'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'customer_serviceBank': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'investor_relations': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'cooperation': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ]
  }
}
